import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export async function getUserPhotoSuggestions(userId, searchQuery = '', refresh = false) {
  const params = {};
  if (searchQuery && searchQuery.trim() !== '') {
    params.q = searchQuery.trim();
  }
  if (refresh) {
    params.refresh = 1;
  }
  return await getAPIResponse(`/v1/user/${userId}/photo-suggestions`, params, 'GET');
}

export async function selectUserPhoto(userId, filename) {
  return await getAPIResponse(`/v1/user/${userId}/select-photo`, { filename }, 'POST');
}

